import { render, staticRenderFns } from "./ImportListModal.vue?vue&type=template&id=01240f45&"
import script from "./ImportListModal.vue?vue&type=script&lang=js&"
export * from "./ImportListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports